import {Exclude, Expose, instanceToPlain, plainToInstance} from "class-transformer";
import * as t from "io-ts";
import {validateJSON, validateJSONNow} from "../web/validation";

export const InvoiceGroupingDefaultValidator = t.intersection([
  t.type({
    id: t.string,
    companyId: t.string,
    regionId: t.string,
    rateModelId: t.string,
    type: t.string,
  }),
  t.partial({
    objectId: t.string,
    invoiceGroupBy: t.string,
    invoiceMaxCost: t.number,
    invoiceMaxLineItem: t.number,
    companyName: t.string,
    rateModelName: t.string,
    objectName: t.string,
    createDttm: t.number,
  }),
]);

export const InvoiceGroupingDefaultArrayValidator = t.array(InvoiceGroupingDefaultValidator);

export type InvoiceGroupingDefault = t.TypeOf<typeof InvoiceGroupingDefaultValidator>;
export type InvoiceGroupingDefaultArray = t.TypeOf<typeof InvoiceGroupingDefaultArrayValidator>;

@Exclude()
export class InvoiceGroupingDefaultEntity {
  @Expose()
  id!: string;

  @Expose()
  companyId!: string;

  @Expose()
  companyName?: string

  @Expose()
  regionId!: string;

  @Expose()
  rateModelId!: string;

  @Expose()
  rateModelName?: string

  @Expose()
  objectId!: string

  @Expose()
  objectName?: string

  @Expose()
  type!: string

  @Expose()
  invoiceGroupBy?: string;

  @Expose()
  invoiceMaxCost?: number;

  @Expose()
  invoiceMaxLineItem?: number;

  @Expose()
  createDttm?: number;

  /**
   * Constructor for InvoiceGroupingDefaultEntity.
   * @hideconstructor
   */
  constructor() {
    // Empty constructor for 'class-transformer'
  }

  static from(value: InvoiceGroupingDefault): InvoiceGroupingDefaultEntity {
    return plainToInstance(InvoiceGroupingDefaultEntity, value, {
      excludeExtraneousValues: true,
    });
  }

  loadTypeValue(): Promise<InvoiceGroupingDefault> {
    const object = instanceToPlain(this, {
      excludeExtraneousValues: true,
    });
    return validateJSON(InvoiceGroupingDefaultValidator, object);
  }

  asTypeValue(): InvoiceGroupingDefault {
    const object = instanceToPlain(this, {
      excludeExtraneousValues: true,
    });
    return validateJSONNow(InvoiceGroupingDefaultValidator, object);
  }
}
